var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ibutton',{staticClass:"refresh",attrs:{"icon":"refresh","text":"Refresh","click":_vm.fetchData}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c(_vm.type,{tag:"component",attrs:{"chartData":_vm.data,"options":_vm.computedOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99142d34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/chart.vue
// module id = XMM3
// module chunks = 1 2 3